function isOnPage(pageName) {
  if (pageName === 'checkout') {
    return window.location.pathname.match(/^\/checkout\/?(\?.*)?$/) !== null;
  }
  
  if (pageName === 'complete') {
    return window.location.pathname.match(/^\/checkout\/complete\/?/) !== null;
  }
  
  if (pageName === 'processing') {
    return window.location.pathname.match(/^\/checkout\/processing/) !== null;
  }
  
  if (pageName === 'payment-resolution') {
    return window.location.pathname.match(/^\/checkout\/payment-resolution\/?/) !== null;
  }
  
  if (pageName === 'payment-resolved') {
    return window.location.pathname.match(/^\/checkout\/payment-resolved($|\/|\?)+\/?/) !== null;
  }
  
  if (pageName === 'payment-change') {
    return window.location.pathname.match(/^\/checkout\/payment-change($|\/|\?)+\/?/) !== null;
  }
  
  if (pageName === 'payment-changed') {
    return window.location.pathname.match(/^\/checkout\/payment-changed($|\/|\?)+\/?/) !== null;
  }
  
  throw new Error(`unsupported page: ${pageName}`);
}

function getRedirectedFromErrorReason() {
  if (window.location.search.indexOf('error') > -1) {
    const redirectFromErrorReason = window.location.search.toString().slice(7);
    return redirectFromErrorReason || true;
  }
  return false;
}

export default {
  isOnPage,
  getRedirectedFromErrorReason,
};
